import { ChangeDetectorRef, Component, OnInit } from "@angular/core";
import { CommonModule, DatePipe } from "@angular/common";
import { ActivatedRoute, Router } from "@angular/router";

import { InventarioIAService } from "../inventario-ia.service";
import { InventarioIA } from "src/app/shared/model/iso42001/inventario-ia.model";

@Component({
  selector: "app-detalle-inventario-ia",
  standalone: true,
  templateUrl: "./detalle-inventario-ia.component.html",
  styleUrls: ["./detalle-inventario-ia.component.css"],
  imports: [CommonModule, DatePipe],
})
export class DetalleInventarioIAComponent implements OnInit {
  inventario: InventarioIA | null = null;
  idInventarioIa = 0;
  loading = false;

  constructor(
    private service: InventarioIAService,
    private route: ActivatedRoute,
    private router: Router,
    private cdr: ChangeDetectorRef,
  ) {}

  ngOnInit(): void {
    const id = this.route.snapshot.paramMap.get("id");
    if (!id) {
      this.regresar();
      return;
    }
    this.idInventarioIa = Number(id);
    this.loading = true;
    this.service.obtener(this.idInventarioIa).subscribe({
      next: (res) => {
        this.inventario = res.inventario || null;
        this.loading = false;
        this.cdr.detectChanges();
      },
      error: () => { this.loading = false; this.cdr.detectChanges(); },
    });
  }

  regresar(): void {
    this.router.navigate(["/admin/inventario-ia/consulta"]);
  }

  verHistorial(): void {
    this.router.navigate(["/admin/inventario-ia/historial", this.idInventarioIa]);
  }

  get propietario(): string {
    if (!this.inventario) return "—";
    return this.inventario.areaNombre || this.inventario.propietarioExterno || "—";
  }
}
